import { render, staticRenderFns } from "./InstanceView.vue?vue&type=template&id=a18690ca&"
import script from "./InstanceView.vue?vue&type=script&lang=ts&"
export * from "./InstanceView.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports